<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div class="lg:mb-4">
            </div>
            <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
              <div class="w-full" 
                v-if="role === 3 && form.idDistribuidor">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.entity_name')}}</label>
                <div class="flex justify-between">
                  <el-form-item prop="idDistribuidor" class="w-full">
                    <base-el-select class="w-full" :options="distribuidores" v-model="form.idDistribuidor" disabled />
                  </el-form-item>
                  <base-button class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailDistributor" :loading="isGeneralLoading"/>
                </div>
              </div>
              <div class="w-full" 
                v-if="(role === 7 || role === 8 || role === 3) &&
                 (form.roleId !== 5 && form.roleId !== 6)">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.entity_name') }}</label>
                <div class="flex justify-between">
                  <el-form-item prop="clienteId" class="w-full">
                    <base-el-select class="w-full" :options="clientes" v-model="form.clienteId" filterable clearable disabled />
                  </el-form-item>
                  <base-button class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading"/>
                </div>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('users.entity_name')}}</label>
                <el-form-item prop="name">
                  <el-input
                    disabled
                    clearable
                    class="w-full"
                    v-model="form.name"
                    maxlength='50'
                  />
                </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$tc('users.email', 1)}}</label>
                <el-form-item prop="email">
                  <el-input
                    disabled
                    clearable
                    class="w-full"
                    v-model="form.email"
                    maxlength='255'
                  />
                </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$tc('app.role', 1)}}</label>
              <el-form-item prop="roleId">
                <base-el-select class="w-full" :options="roles" v-model="form.roleId" clearable disabled />
              </el-form-item>
            </div>
            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('users.tipo_auth')}}</label>
              <el-form-item prop="tipoAuth">
                <base-el-select class="w-full" :options="tiposAuthFiltered" v-model="form.tipoAuth" clearable disabled />
              </el-form-item>
            </div>
            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('app.language') }}</label>
              <el-form-item prop="idioma">
                <base-el-select class="w-full" :options="tiposIdioma" v-model="form.idioma" :option-label="langOptionLabel" disabled />
              </el-form-item>
            </div>
            <div class="mb-6">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <el-switch class="switch-text break-normal" disabled v-model="form.verTodoStatuses" :active-text="$t('configurations.ver_todo_statuses')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoStatuses" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <el-switch class="switch-text break-normal" disabled v-model="form.verTodoCompanies" :active-text="$t('configurations.ver_todo_companies')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoCompanies" class="ml-1"/>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="$t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.delete')"
            icon="check"
            @click="deleteUser()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.restore')"
            icon="check"
            @click="restoreUser()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <Dialog
            :title="$t('users.delete_user')"
            :visible.sync="showModal"
            width="40%"
            custom-class="min-width-dialog"
            center>
            <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
                <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
              </div>
            </template>
      </Dialog>
    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { getClients } from '@/services/clients/getClients'
import { getUser } from '@/services/configurations/getUser'
import { i18n } from '@/i18n'
import { email as emailRegex } from '@/utils/regex'
import { deleteTrashUser } from '@/services/trash/deleteTrashUser'
import { restoreTrashUser } from '@/services/trash/restoreTrashUser'
import { Dialog } from 'element-ui'
import { getDistributors } from '@/services/distributors/getDistributors'

export default {
  /* eslint-disable camelcase */
  name: 'detalle-papelera-usuario',
  components: {
    DetailLayout,
    Dialog
  },
  data: function () {
    return {
      showGeneratePassword: false,
      searchView: false,
      activeName: 'es',
      localUserId: null,
      header: {
        title: 'DETALLE DE USUARIO BORRADO',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'trash/users'
      },
      form: this.getDefaultForm(),
      distribuidores: [],
      clientes: [],
      tooltipVerTodoStatuses: i18n.t('tooltip.ver_todo_statuses'),
      tooltipVerTodoCompanies: i18n.t('tooltip.ver_todo_companies'),
      toolAccesoAAD: i18n.t('tooltip.acceso_AAD'),
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      showModal: false,
      processMessage: i18n.t('app.delete_permanent_current_confirmation', { entity: i18n.t('users.entity_name').toLowerCase() }),
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    roles: function () {
      return this.$store.getters['config/ROLES'].filter(r => {
        if (r.only) {
          return r.only.includes(this.role)
        }
        return true
      })
    },
    id: function () {
      return this.$route.params.id
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    getIdUsuarioLogged: function () {
      return this.$store.getters['auth/user'].IdUsuario
    },
    isSameUser: function () {
      return this.getIdUsuarioLogged === this.id
    },
    tiposAuthFiltered: function () {
      var arrayAuthTypes = this.$store.getters['config/TIPOS_AUTH']
      if (!this.hasAADIntegration) {
        arrayAuthTypes = arrayAuthTypes.filter(x => !['AAD', 'Mixto'].includes(x.key))
      }
      if (!this.hasSAML2Integration) {
        arrayAuthTypes = arrayAuthTypes.filter(x => !['SAML2', 'MixtoSAML2'].includes(x.key))
      }
      return arrayAuthTypes
    },
    tiposIdioma: function () {
      return this.$store.getters['config/TIPOS_IDIOMA']
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: async function () {
    const localUser = this.$store.getters['auth/user']
    this.localUserId = localUser.IdUsuario
    const breadcrumbs = []
    
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, value: x.idCliente }))

      if (this.role === 3) {
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataDistributors))
        }
        this.distribuidores = dataDistributors.Distribuidores.map(x => ({ label: x.Nombre, value: x.IdDistribuidor }))
      }
    }

    await this.downloadData(this.id)
    breadcrumbs.push({ path: 'trash/users', name: i18n.t('trash.header') })
    breadcrumbs.push({ path: 'trash/users', name: i18n.t('trash.users') })
    breadcrumbs.push({ path: '', name: this.form.name })
    this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    langOptionLabel: function (option) {
      return this.isSameUser ? option.localName : option.name
    },
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    goDetailDistributor () {
      const id = this.form.idDistribuidor
      this.$router.push({ name: 'configurations/distributors/details', params: { id } })
    },
    deleteUser () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsUsuario: []
        }
        payload.idsUsuario.push(this.id)
        const response = await deleteTrashUser(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    restoreUser: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsUsuario: []
        }
        payload.idsUsuario.push(this.id)
        const response = await restoreTrashUser(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    getDefaultForm: function () {
      return {
        id: 2,
        name: '',
        email: '',
        company: '',
        active: false,
        idDistribuidor: '',
        created_at: '',
        password: '',
        repeat_password: '',
        clienteId: '',
        roleId: '',
        verTodoStatuses: false,
        verTodoCompanies: false,
        tipoAuth: 0,
        idioma: '',
      }
    },
    watchFormHandler: function ({
      certificate,
      send_alerts
    }) {},
    toggleDialogs: function () {
      this.showGeneratePassword = !this.showGeneratePassword
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      if (!emailRegex.test(value)) {
        callback(new Error(i18n.t('validation.email')))
      } else {
        callback()
      }
    },
    goBack: function () {
      this.$router.push({ name: 'trash/users' })
    },
    downloadData: async function (id) {
      let user = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idUsuario: id,
          borrado: true,
        }
        user = await getUser(params)
        this.setUser(user.respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return user
    },
    setUser: function (user) {
      const role = this.roles.find(r => r.id === user.idRol)
      const arrayAuthTypes = this.$store.getters['config/TIPOS_AUTH']
      const tipoAuth = arrayAuthTypes.find(r => r.id === user.idTipoAutenticacion)
      this.form.id = user.idUsuario
      this.form.name = user.Usuario
      this.form.email = user.Email
      this.form.idDistribuidor = user.idDistribuidor
      this.form.company = user.Empresa
      this.form.active = user.active
      this.form.created_at = user.created_at
      this.form.roleId = role?.id ?? user.idRol
      this.form.clienteId = user.idCliente
      this.form.verTodoStatuses = user.VerTodoEstados
      this.form.verTodoCompanies = user.VerTodoEmpresas
      this.form.tipoAuth = tipoAuth?.id ?? user.idTipoAutenticacion
      this.form.idioma = user.LangCode
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.name
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
